let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("4wa7C")).then(() => parcelRequire('7OI81'));